import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import LabelInfo from '../../../../components/LabelInfo';
import OrderLabelInfoDescription from '../OrderLabelInfoDescription';
import { ORDER_LIST_SUMMARY_TYPE_TEXT } from '../../../../constants/service/app/orderConstants';
import { asyncSimpleModal, setNumberWithComma } from '../../../../lib/common';
import './OrderLabelInfo.scss';

const OrderLabelInfo = (props) => {
  const { info, infoUnit, orderSummaryType } = props;

  return (
    <LabelInfo
      className="order-label-info"
      label={
        <span className="order-label">
          <span>{ORDER_LIST_SUMMARY_TYPE_TEXT[orderSummaryType]}</span>
          <QuestionCircleOutlined
            onClick={async () => {
              await asyncSimpleModal({
                title: ORDER_LIST_SUMMARY_TYPE_TEXT[orderSummaryType],
                message: <OrderLabelInfoDescription orderSummaryType={orderSummaryType} />,
              });
            }}
          />
        </span>
      }
      info={setNumberWithComma(info, infoUnit)}
    />
  );
};

export default OrderLabelInfo;
